import React from 'react';
import {ZoomInIcon, ZoomOutIcon} from './Icons';
import {ZoomDropdown} from './ZoomDropdown';
import {CONSTANTS} from '../../ZoomImage.utils';
import {ZoomContext} from '../../index';

/**
 * ZoomMenu:
 *  - Component renders the ZoomIn/Out Controls for PopupZoomImage component
 */
export function ZoomMenu() {
  const {state, setZoom} = React.useContext(ZoomContext);

  const onDropdownChange = (option) => setZoom(option.value);

  const zoomIN = () => setZoom(state.zoomValue + CONSTANTS.ZOOM_VALUE_RATE);

  const zoomOUT = () => setZoom(state.zoomValue - CONSTANTS.ZOOM_VALUE_RATE);

  const setZoomInDisabled = (className) => {
    if (state.zoomValue >= CONSTANTS.MAX_ZOOM) {
      return className + ' disabled';
    } else {
      return className;
    }
  };

  const setZoomOutDisabled = (className) => {
    if (state.zoomValue <= CONSTANTS.MIN_ZOOM) {
      return className + ' disabled';
    } else {
      return className;
    }
  };

  return (
    <div className='zoomMenuBlock'>
      <div className={setZoomInDisabled('zoomMenuBlock_left')} onClick={zoomIN}>
        <ZoomInIcon className='icon icon-zoomIn' />
      </div>
      <div className='zoomMenuBlock_middle'>
        <ZoomDropdown onChange={onDropdownChange} />
      </div>
      <div
        className={setZoomOutDisabled('zoomMenuBlock_right')}
        onClick={zoomOUT}>
        <ZoomOutIcon className='icon icon-zoomOut' />
      </div>
    </div>
  );
}
